import { createMockConversationDebugResponse as e, withDelay as t } from "./ConversationInspectorResource.mocks.js";
import { API as n, Resource as r } from "@coveo/platform-client";
//#region src/resources/conversation-inspector/ConversationInspectorResource.ts
var i = class extends r {
	static {
		this.baseUrl = `/rest/organizations/${n.orgPlaceholder}/conversations`;
	}
	getConversationDebug(n) {
		return t(e(n));
	}
};
//#endregion
export { i as ConversationInspectorResource };

//# sourceMappingURL=ConversationInspectorResource.js.map